const Name = {
    Block: {
        Artist: {
            Container: 'artistContainer',
            Image: 'artistImage',
            Meta: 'artistMeta'
        },
        AuthenticityStatement: 'authenticityStatement',
        Client: {
            ContactMeta: 'clientContactMeta'
        },
        Columns: 'columns',
        Company: {
            ContactMeta: 'companyContactMeta',
            Logo: 'companyLogo',
            StaffName: 'staffName'
        },
        Consignment: {
            Meta: 'consignmentMeta',
            Terms: 'consignmentTerms',
            Totals: 'consignmentTotals'
        },
        Date: 'date',
        Inventory: {
            Container: 'inventoryContainer',
            Image: 'inventoryImage',
            List: 'inventoryList',
            Meta: 'inventoryMeta'
        },
        ListOrderNumber: 'listOrderNumber',
        ListTitle: 'listTitle',
        Name: 'name',
        NonBreakingContainer: 'nonBreakingContainer',
        Notes: 'notes',
        Number: 'number',
        PaymentCredit: {
            Amount: 'paymentAmount',
            CreditsContainer: 'creditsContainer',
            Date: 'paymentDate',
            Method: 'paymentMethod',
            PaymentsContainer: 'paymentsContainer'
        },
        Separator: 'separator',
        Signature: 'signature',
        Stage: 'stage',
        TaxLine: 'taxLine',
        Text: 'text',
        Total: {
            Balance: 'balance',
            Discount: 'discount',
            GrandTotal: 'grandTotal',
            Paid: 'paid',
            PromoCodes: 'promoCodes',
            Refunded: 'refunded',
            Shipping: 'shipping',
            Subtotal: 'subtotal',
            Taxes: 'taxes'
        },
        TrackingNumber: 'trackingNumber',
        ValidThrough: 'validThrough'
    },

    Config: {
        ArtistBio: 'bios',
        CertificateOfAuthenticity: 'certificates',
        Consignment: 'consignments',
        Invoice: 'invoices',
        Mosaic: 'mosaics',
        Offer: 'offers',
        Pricelist: 'pricelists',
        PurchaseOrder: 'purchaseOrders',
        Tearsheet: 'tearsheets'
    },

    Content: {
        ArtistBioItem: 'artistBioItem',
        ArtistInventoryItem: 'artistInventoryItem',
        CertificateItem: 'certificateItem',
        ConsignmentLineItem: 'consignmentLineItem',
        CreditLineItem: 'creditLineItem',
        InvoiceLineItem: 'invoiceLineItem',
        MosaicItem: 'mosaicItem',
        PageHeader: 'pageHeader',
        PaymentLineItem: 'paymentLineItem',
        PricelistInventoryItem: 'pricelistInventoryItem',
        PurchaseOrderLineItem: 'purchaseOrderLineItem',
        TearsheetItem: 'tearsheetItem'
    },

    Stylesheet: {
        Header1: 'h1',
        Header2: 'h2',
        Header3: 'h3',
        Header4: 'h4',
        Paragraph: 'p'
    }
}
export default Name;